import { useCallback, useEffect } from 'react';
export default function useKeyboardEvensts({
  playing,
  loading,
  onPlayPause,
  onFullscreen,
  onPictureInPicture
}) {
  const onSpace = useCallback(() => {
    onPlayPause();
  }, [onPlayPause]);
  const onF = useCallback(() => {
    onFullscreen();
  }, [onFullscreen]);
  const onP = useCallback(() => {
    onPictureInPicture();
  }, [onPictureInPicture]);
  const onKeyDown = useCallback(evt => {
    switch (evt.keyCode) {
      case 32:
        onSpace();
        break;
      case 70:
        onF();
        break;
      case 80:
        onP();
        break;
      default:
    }
  }, [onSpace, onF, onP]);
  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
}